<template>
  <div ref="postData" class="postData"></div>
</template>

<script>
  import * as echarts from "echarts";
  export default {
    name: "PostData",
    props: {
      data: {
        type: Object,
        default: () => {
          return {
            x: [],
            y: []
          }
        }
      },
    },
    data() {
      return {
        charts: null
      }
    },
    watch: {
      data() {
        this.reload()
      }
    },
    mounted() {
      this.charts = echarts.init(this.$refs["postData"])
    },
    methods: {
      reload() {
        var option = {
          title: {
            text: ''
          },
          tooltip: {
            trigger: 'axis'
          },
          legend: {

          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          toolbox: {
            feature: {
              saveAsImage: {}
            }
          },
          xAxis: {
            type: 'category',
            boundaryGap: true,
            data: this.data.x,
          },
          yAxis: {
            type: 'value'
          },
          series: this.data.y
        };

        this.charts.setOption(option)
      }
    }
  };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .postData {
    height: 500px;
  }
</style>
